export const EXPRESS_BOOKING_GIF_URL =
  'https://cdn.starclinch.in/starclinchcom/express-bookings/final_eb.gif';
